// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bBeKPBxwvIu4io {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  display: flex;
  align-items: center;
  column-gap: var(--ds-space-050, 4px);
}
.bUxvE0d0Ql9JOU {
  display: flex;
  flex-direction: column;
  row-gap: var(--ds-space-100, 8px);
}
.E1T9c99Eq0BY0i {
  justify-content: left;
}
.fAERXN0U79YDtD {
  margin-left: var(--ds-space-100, 8px);
}
.bY2v5s1C43Q9uu {
  margin-top: var(--ds-space-150, 12px);
}
`, ""]);
// Exports
export var header = `bBeKPBxwvIu4io`;
export var wrapper = `bUxvE0d0Ql9JOU`;
export var button = `E1T9c99Eq0BY0i`;
export var name = `fAERXN0U79YDtD`;
export var popoverSection = `bY2v5s1C43Q9uu`;
export default ___CSS_LOADER_EXPORT___;
